var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 3.55859C2.25 2.73017 2.92157 2.05859 3.75 2.05859H6C6.82843 2.05859 7.5 2.73017 7.5 3.55859V5.80859C7.5 6.63702 6.82843 7.30859 6 7.30859H3.75C2.92157 7.30859 2.25 6.63702 2.25 5.80859V3.55859ZM6 3.55859H3.75V5.80859H6V3.55859Z",
    fill: "#8E8E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.55859C12 2.73017 12.6716 2.05859 13.5 2.05859H15.75C16.5784 2.05859 17.25 2.73017 17.25 3.55859V5.80859C17.25 6.63702 16.5784 7.30859 15.75 7.30859H13.5C12.6716 7.30859 12 6.63702 12 5.80859V3.55859ZM15.75 3.55859H13.5V5.80859H15.75V3.55859Z",
    fill: "#8E8E8E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 13.3086C2.25 12.4802 2.92157 11.8086 3.75 11.8086H6C6.82843 11.8086 7.5 12.4802 7.5 13.3086V15.5586C7.5 16.387 6.82843 17.0586 6 17.0586H3.75C2.92157 17.0586 2.25 16.387 2.25 15.5586V13.3086ZM6 13.3086H3.75V15.5586H6V13.3086Z",
    fill: "#8E8E8E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.659 12.4676C13.081 12.0456 13.6533 11.8086 14.25 11.8086H16.5C16.9142 11.8086 17.25 12.1444 17.25 12.5586C17.25 12.9728 16.9142 13.3086 16.5 13.3086H14.25C14.0511 13.3086 13.8603 13.3876 13.7197 13.5283C13.579 13.6689 13.5 13.8597 13.5 14.0586V16.3086C13.5 16.7228 13.1642 17.0586 12.75 17.0586C12.3358 17.0586 12 16.7228 12 16.3086V14.0586C12 13.4619 12.2371 12.8896 12.659 12.4676Z",
    fill: "#8E8E8E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 15.5586C16.9142 15.5586 17.25 15.8944 17.25 16.3086V16.3161C17.25 16.7303 16.9142 17.0661 16.5 17.0661C16.0858 17.0661 15.75 16.7303 15.75 16.3161V16.3086C15.75 15.8944 16.0858 15.5586 16.5 15.5586Z",
    fill: "#8E8E8E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 5.05859C10.1642 5.05859 10.5 5.39438 10.5 5.80859V8.05859C10.5 8.65533 10.2629 9.22763 9.84099 9.64958C9.41903 10.0715 8.84674 10.3086 8.25 10.3086H6C5.58579 10.3086 5.25 9.97281 5.25 9.55859C5.25 9.14438 5.58579 8.80859 6 8.80859H8.25C8.44891 8.80859 8.63968 8.72958 8.78033 8.58892C8.92098 8.44827 9 8.25751 9 8.05859V5.80859C9 5.39438 9.33579 5.05859 9.75 5.05859Z",
    fill: "#8E8E8E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 9.55859C2.25 9.14438 2.58579 8.80859 3 8.80859H3.0075C3.42171 8.80859 3.7575 9.14438 3.7575 9.55859C3.7575 9.97281 3.42171 10.3086 3.0075 10.3086H3C2.58579 10.3086 2.25 9.97281 2.25 9.55859Z",
    fill: "#8E8E8E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.80859C9 2.39438 9.33579 2.05859 9.75 2.05859H9.7575C10.1717 2.05859 10.5075 2.39438 10.5075 2.80859C10.5075 3.22281 10.1717 3.55859 9.7575 3.55859H9.75C9.33579 3.55859 9 3.22281 9 2.80859Z",
    fill: "#8E8E8E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 11.8086C10.1642 11.8086 10.5 12.1444 10.5 12.5586V12.5661C10.5 12.9803 10.1642 13.3161 9.75 13.3161C9.33579 13.3161 9 12.9803 9 12.5661V12.5586C9 12.1444 9.33579 11.8086 9.75 11.8086Z",
    fill: "#8E8E8E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9.55859C12 9.14438 12.3358 8.80859 12.75 8.80859H13.5C13.9142 8.80859 14.25 9.14438 14.25 9.55859C14.25 9.97281 13.9142 10.3086 13.5 10.3086H12.75C12.3358 10.3086 12 9.97281 12 9.55859Z",
    fill: "#8E8E8E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 8.80859C16.9142 8.80859 17.25 9.14438 17.25 9.55859V9.56609C17.25 9.98031 16.9142 10.3161 16.5 10.3161C16.0858 10.3161 15.75 9.98031 15.75 9.56609V9.55859C15.75 9.14438 16.0858 8.80859 16.5 8.80859Z",
    fill: "#8E8E8E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 14.8086C10.1642 14.8086 10.5 15.1444 10.5 15.5586V16.3086C10.5 16.7228 10.1642 17.0586 9.75 17.0586C9.33579 17.0586 9 16.7228 9 16.3086V15.5586C9 15.1444 9.33579 14.8086 9.75 14.8086Z",
    fill: "#8E8E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr_code.cb84e2b6d6f26906531fc0358d6de965.svg";
export { ForwardRef as ReactComponent };